import 'promise-polyfill';
import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import createPersistedState from "vuex-persistedstate";

import LoginModule from './modules/login'
import graphs from './modules/graphs'
import conversation from './modules/conversation'
import negotiation from './modules/negotiation'
import offers from './modules/offers'
import allPrices from './modules/allPrices'
import accounts from './modules/accounts'
import terminals from './modules/terminals'
import inputCheckers from './modules/inputCheckers'
import notifications from './modules/notificationPanel'
import orders from './modules/orders'
import selectFavourites from './modules/selectFavourites'
import fuelsType from './modules/fuelsType'
import sellerTabs from './modules/sellerServiceTabs'
import sellerOffers from './modules/sellerOffers'
import livePrices from './modules/livePrices'
import sellerDashboard from './modules/sellerDashboard'
import sharedMutations from 'vuex-shared-mutations';
import buyerOpen from './modules/buyerOpen';
import rules from './modules/rules';
import metadata from './modules/metadata';
import itemRemoval from "./modules/itemRemoval";
import orderCapture from "./modules/orderCapture";
import deliveryLocations from "./modules/deliveryLocations";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        axios,
    },
    plugins: [sharedMutations({ predicate: ['login/LOGIN_USER'] })],
    modules:{
        plugins: [createPersistedState()],
        namespaced:true,
        login:LoginModule,
        graphs,
        conversation,
        negotiation,
        offers,
        notifications,
        allPrices,
        accounts,
        terminals,
        inputCheckers,
        orders,
        selectFavourites,
        fuelsType,
        sellerTabs,
        sellerOffers,
        livePrices,
        sellerDashboard,
        buyerOpen,
        rules,
        metadata,
        itemRemoval,
        orderCapture,
        deliveryLocations
    },
})